import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class Preloader {
    constructor(wrapper) {
        this.wrapper = wrapper;
        this.circleWrapper = this.wrapper.querySelector('.j-preloader__wrapper');

        this._init();
    }

    _init() {
        this.circleWrapper.classList.add('is-animate');

        setTimeout(() => {
            window.scrollTo(0, 0);
            Utils.bodyFixed(this.wrapper);
            const scaleSize =
                (Math.sqrt(Math.pow(Utils.getWindowWidth(), 2) + Math.pow(Utils.getWindowHeight(), 2)) /
                this.circleWrapper.clientWidth) + 1;
            const holeScale =
                Math.sqrt(Math.pow(Utils.getWindowWidth(), 2) + Math.pow(Utils.getWindowHeight(), 2)) / 2 / 30;

            this.wrapper.style.setProperty('--scale', scaleSize);
            this.wrapper.style.setProperty('--hole-scale', holeScale);
            this.wrapper.classList.add('is-finished');
        }, 2500);
        setTimeout(() => {
            observer.publish('preloader:finished');
            Utils.bodyStatic();
            Utils.removeElement(this.wrapper);
        }, 3300);
    }
}

export default Preloader;
